import * as React from 'react';
import cn from 'classnames';
import { Close16, IconButton } from '@cian/ui-kit';

import * as styles from './styles.css';
import ringImg from '../../assets/ring.png';
import { IContainerLayoutProps } from '../../ContainerLayout';

export const DesktopContainerLayout: React.FC<IContainerLayoutProps & { onClose: () => void }> = ({
  title,
  content,
  actions,
  isWithRingLabelImage,
  isWithRightSideImage,
  onClose,
  actionsGap,
}) => {
  return (
    <section className={cn(styles['container'], { [styles['with-image']]: isWithRightSideImage })}>
      <h2 className={styles['title']}>
        {title}
        {isWithRingLabelImage && (
          <span className={styles['label']}>
            Онлайн-сделка
            <img src={ringImg} alt="" />
          </span>
        )}
      </h2>
      <div className={styles['content']}>{content}</div>
      <div className={cn(styles['actions'], styles[`actions-gap-${actionsGap}`])}>{actions}</div>
      <div className={styles['close-button']}>
        <IconButton aria-label='Скрыть блок "Онлайн.Сделка"' onClick={onClose} icon={<Close16 />} />
      </div>
    </section>
  );
};
